(() => {
  'use strict';

  const connection =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;

  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) {
    return;
  }

  const prefetched = new Set();
  let timer;

  function eligibleLink(target) {
    const link = target.closest?.('a[href]');
    if (!link) return null;
    if (link.target && link.target !== '_self') return null;
    if (link.hasAttribute('download')) return null;

    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return null;
    if (url.pathname === location.pathname && url.search === location.search) return null;
    if (!/^\/(products|collections|pages|blogs|search)(\/|$)/.test(url.pathname)) return null;

    return url;
  }

  function prefetch(url) {
    const href = url.href;
    if (prefetched.has(href)) return;
    prefetched.add(href);

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    link.as = 'document';
    document.head.appendChild(link);
  }

  document.addEventListener(
    'pointerover',
    (event) => {
      if (event.pointerType === 'touch') return;
      const url = eligibleLink(event.target);
      if (!url) return;
      clearTimeout(timer);
      timer = setTimeout(() => prefetch(url), 65);
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerout',
    () => clearTimeout(timer),
    { passive: true }
  );

  document.addEventListener(
    'touchstart',
    (event) => {
      const url = eligibleLink(event.target);
      if (url) prefetch(url);
    },
    { passive: true, capture: true }
  );

  document.addEventListener('focusin', (event) => {
    const url = eligibleLink(event.target);
    if (url) prefetch(url);
  });
})();